import { BRAND_ASSETS } from "@/lib/brand";
import { cn } from "@/lib/utils";
import { BrandLogotype } from "./BrandLogotype";

interface BrandWordmarkProps {
  collapsed?: boolean;
  subtitle?: string;
  /** `light` = on white strip; `dark` = on blue sidebar */
  tone?: "light" | "dark";
  className?: string;
}

export function BrandWordmark({
  collapsed = false,
  subtitle = "Practice Portal",
  tone = "light",
  className,
}: BrandWordmarkProps) {
  if (collapsed) {
    return (
      <div className={cn("flex h-16 w-16 items-center justify-center", className)}>
        <img
          src={BRAND_ASSETS.loginMark}
          alt="Orange"
          width={64}
          height={64}
          className="h-14 w-14 object-contain"
          decoding="async"
        />
      </div>
    );
  }

  const subtitleClass =
    tone === "dark"
      ? "text-[9px] font-semibold uppercase tracking-wider text-white/55"
      : "text-[8px] font-semibold uppercase tracking-wider text-muted-foreground";

  return (
    <div className={cn("flex items-center gap-2.5 min-w-0", className)}>
      <img
        src={BRAND_ASSETS.loginMark}
        alt=""
        width={400}
        height={367}
        aria-hidden
        className="h-10 w-10 shrink-0 object-contain"
      />
      <div className="min-w-0 leading-tight">
        <p className="text-[13px] leading-none">
          <BrandLogotype
            tone={tone === "dark" ? "on-dark" : "default"}
            className="text-[13px]"
          />
        </p>
        <p className={subtitleClass}>{subtitle}</p>
      </div>
    </div>
  );
}
